import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AffiliateLanding from './components/AffiliateLanding';
import AffiliateAbout from './components/AffiliateAbout';
import Dashboard from './components/Dashboard';
import Terms from './components/Terms';
import Payout from './components/Payout';
import Signup from './components/Signup';
import Login from './components/Login';
import AffiliateBlogPost from './components/AffiliateBlogPost';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<AffiliateLanding />} />
          <Route path="/affiliate" element={<AffiliateLanding />} />
          <Route path="/about" element={<AffiliateAbout />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/payout" element={<Payout />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/blog/:slug" element={<AffiliateBlogPost />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
